import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=36435046"
import script from "./CategoryDialog.vue?vue&type=script&lang=js"
export * from "./CategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports